const PRIMARY = {
    lighter: '#6573cc',
    light: '#263172',
    main: '#3949AB',
    dark: '#2c3985',
    darker: '#263172',
    contrastText: '#fff',
    main_active: '#eaf0f1',
};

const SECONDARY = {
    lighter: '#FFFFFF',
    main: '#474555',
};

const palette = {
    common: { black: '#424242', white: '#fff' },
    primary: { ...PRIMARY },
    secondary: { ...SECONDARY },
};

export default palette;
